import { FieldProps } from "../../reusable_components/input_fields/Input";
import { BackendOption, SelectOption } from "./UploadSpreadsheetModal.types";

export const handleChange = (
  elements: FieldProps[],
  setElements: React.Dispatch<React.SetStateAction<FieldProps[]>>,
  field_id: string,
  event: any
) => {
  const newElements = elements.map((field) => {
    if (field_id === field.id) {
      if (field.type === "file") {
        field.value = event[0];
      } else {
        field.value = event.target.value;
      }
    }
    return field;
  });
  setElements(newElements);
};

export const handleClose = (
  setfileuploading: (val: boolean) => void,
  onHide: () => void
) => {
  setfileuploading(false);
  onHide();
};


export const buildSelectOptions = (
  data: BackendOption[]
): SelectOption[] => {

  if (!data?.length) return [];

  return data.map(item => ({
    id: item.code?.replace(/^for_/, ""),
    label: item.label?.replace(/^For /, ""),
    value: item.value?.replace(/^For/, "")
  }));
};
